var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"list-position"},[_c('button',{staticClass:"iconfont icon-zhiding",on:{"click":function($event){return _vm.toTop(0)}}}),_vm._v(" "),_c('button',{staticClass:"iconfont icon-zhiding",on:{"click":function($event){return _vm.toTop(1)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d866bf9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/question-assembly/src/toTop.vue
// module id = 258
// module chunks = 0